
let nextLensId = 0;

/**
 * Generate a unique lens ID
 */
export function generateLensId(): string {
  return `lens_${nextLensId++}_${Date.now()}`;
}

